export enum SearchBy {
  LabelOrName = 'labelOrName',
  Address = 'address',
  Line = 'line',
}
